import { OpenInNew } from "@mui/icons-material";
import { Button, Stack, Typography } from "@mui/material";
import { T } from "components/util/t";
import { Card } from "../cards/Card";
import { Link, useParams } from "react-router-dom";
import { getTeamName } from "./TeamRegistrationForm";

export const RegisteredTeam = ({ entry, divisionId, eventTeam }) => {
    const { id: eventId } = useParams();

    return (
        <Card marginBottom={1}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Typography variant="subtitle3" color="textSecondary">
                    <T team={getTeamName(entry.name, eventTeam)}>team_already_entered</T>
                </Typography>
                <Button component={Link} to={`/user/events/${eventId}/divisions/${divisionId}`} target="_blank">
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                        <span>View in dashboard</span>
                        <OpenInNew />
                    </Stack>
                </Button>
            </Stack>
        </Card>
    );
};
